import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'snack-bar-message',
    template: '{{ data | translate }}',
    styles: [`
    :host {
      white-space: pre-wrap
    }
  `],
    standalone: false
})

export class SnackBarMessageComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {
  }
}
